var _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMergedGraph(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M370 202a60.068 60.068 0 00-60-60h-10v40h10a20.023 20.023 0 0120 20v8h40z",
    fill: "#5222f2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 37",
    d: "M370 452v-82h82a60.068 60.068 0 0060-60V60a60.068 60.068 0 00-60-60H202a60.068 60.068 0 00-60 60v82H60a60.068 60.068 0 00-60 60v250a60.068 60.068 0 0060 60h250a60.068 60.068 0 0060-60zM60 472a20.023 20.023 0 01-20-20V202a20.023 20.023 0 0120-20h122V60a20.023 20.023 0 0120-20h250a20.023 20.023 0 0120 20v250a20.023 20.023 0 01-20 20H330v122a20.023 20.023 0 01-20 20z",
    fill: "#5222f2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 41",
    fill: "#5222f2",
    d: "M300 142v40H182v-40z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 42",
    fill: "#5222f2",
    d: "M370 210v120h-40V210z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 38",
    d: "M212 330h-10a20.023 20.023 0 01-20-20v-8h-40v8a60.068 60.068 0 0060 60h10z",
    fill: "#5222f2"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 43",
    fill: "#5222f2",
    d: "M330 330v40H212v-40z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 44",
    fill: "#5222f2",
    d: "M182 182v120h-40V182z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergedGraph);
export default __webpack_public_path__ + "static/media/merged-graph.3234d6126a4337ccc776f2cca69695e4.svg";
export { ForwardRef as ReactComponent };